export default __webpack_public_path__ + "media/images/plus-sign-811ac4401d51005c733d56296e9b5cb1.svg";